// spec: specs/comps
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/prototypes/comps_/concepts")({
  validateSearch: (search: Record<string, unknown>) => ({
    // An ISBN-like id arrives parsed as a number.
    query:
      typeof search.query === "string" || typeof search.query === "number"
        ? String(search.query)
        : undefined,
  }),
});
